"use client";

import { c as _c } from "react/compiler-runtime";
import { PersonIcon } from "@navikt/aksel-icons";
import { PageContainer, RootPages, SideMenu } from "@navikt/dinesykmeldte-sidemeny";
import type { ReactNode } from "react";
interface Props {
  narmesteLederId: string;
  employeeFnr: string;
  employeeName: string;
  children: ReactNode;
}
export const ArbeidsgiverPageContainer = t0 => {
  const $ = _c(14);
  const {
    narmesteLederId,
    employeeFnr,
    employeeName,
    children
  } = t0;
  let t1;
  if ($[0] !== employeeFnr || $[1] !== employeeName) {
    t1 = {
      fnr: employeeFnr,
      navn: employeeName
    };
    $[0] = employeeFnr;
    $[1] = employeeName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== employeeName) {
    t2 = {
      title: employeeName,
      Icon: PersonIcon
    };
    $[3] = employeeName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      Soknader: 0,
      Sykmeldinger: 0,
      Meldinger: false,
      Dialogmoter: 0,
      Oppfolgingsplaner: 0,
      DineSykmeldte: 0
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== employeeName || $[7] !== narmesteLederId) {
    t4 = <SideMenu sykmeldtName={employeeName} sykmeldtId={narmesteLederId} activePage={RootPages.Oppfolgingsplaner} routes={t3} />;
    $[6] = employeeName;
    $[7] = narmesteLederId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <PageContainer sykmeldt={t1} header={t2} navigation={t4}>{children}</PageContainer>;
    $[9] = children;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};